package com.advaita.cloud.drive.ui.store

import com.advaita.cloud.drive.shared.FileDto
import kotlin.js.Date

/** Sortable columns of the folder view. Type/Status/actions are deliberately not sortable. */
enum class TableSortKey { NAME, SIZE, CREATED }

/** First click on a header: names read A→Z; metrics read biggest/newest first (mirrors the API defaults). */
fun defaultAscending(key: TableSortKey): Boolean = key == TableSortKey.NAME

/**
 * Client-side ordering for the folder view. The non-recursive /api/files
 * deliberately rejects `sort` (this view is always fully loaded), so the table
 * owns ordering. createdAt has VARIABLE sub-second precision (Instant.toString),
 * so it is compared as a parsed date, never as a string. Ties break by
 * lowercased name then id, so re-sorts are stable and deterministic.
 */
fun sortedForTable(files: List<FileDto>, key: TableSortKey, ascending: Boolean): List<FileDto> {
    val base: Comparator<FileDto> = when (key) {
        TableSortKey.NAME -> compareBy { it.displayName.lowercase() }
        TableSortKey.SIZE -> compareBy { it.sizeBytes ?: 0L }
        TableSortKey.CREATED -> compareBy { Date(it.createdAt).getTime() }
    }
    val directed = if (ascending) base else base.reversed()
    return files.sortedWith(directed.thenBy { it.displayName.lowercase() }.thenBy { it.id })
}
